import React, { useCallback, useEffect, useState } from 'react';
import {
    BREADCRUMB,
    HEROBANNER,
    PACKAGEGRID,
    PAGETITLE,
    POPULARPACKAGE,
} from "../../constants/rootElements";
import { TermsAndConditionsProvider } from '../../context/terms-and-conditions';
import { useFeeAlertInjectionScript, useGoogleAnalyticsHandler } from '../../hooks';
import { gaPackageBrowsePageLoad } from '../../util/googleAnalytics';
import { appendTermsAndConditionsLink } from '../../util/termsAndConditions';
import { Breadcrumb } from '../breadcrumb';
import GradPackageTabs from '../hs-grad/gradPackageTabs';
import { TitleBar } from "../packageBrowseTitle";
import { renderPromoMessages } from '../promoMessages';
import HeroBanner from './heroBanner';
import { PopularPackage } from './popularPackage';

export const HSGraduation = (props) => {
    const { packageBrowseData, pageContentData, affiliationData } = props.appData
    const [ gradPackageGroupData, setGradPackageGroupData ] = useState({});
    const [ popularPackageItems, setPopularPackageItems ] = useState([]);
    const [promoMessages, setPromoMessages] = useState([]);
    const [popularPackageName, setPopularPackageName] = useState("");
    const [popularPackageProdRefCode, setPopularPackageProdRefCode] = useState("");
    const [popularPackageRepMessage, setPopularPackageRepMessage] = useState("");
    const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);

    useFeeAlertInjectionScript(feeAlertRequestData)
    const googleAnalytics = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const PBBreadcrumb = pageContentData?.find(data => data.contentType === "Navigation")
    const HsHeroBanner = pageContentData?.find(data => data.contentType === "GradPackageBrowseBanner")
	const HsPopularPackage = pageContentData?.find(data => data.contentType === "MascotPackage")
    const HsPaymentPromo = pageContentData?.find(data => data.contentType === "PaymentPromo")
	const HsPackages = pageContentData?.find(data => data.contentType === "Packages")
	const HsRepAnnouncement = pageContentData?.find(data => data.contentType === "RepAnnouncement")
    const HsPageTitle = pageContentData?.find(data => data.contentType === "ProductBrowseTitle")
    const ProductBrowsePromoMsg = Boolean(
		pageContentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

    useEffect(()=> {
        if(Object.keys(packageBrowseData)?.length > 0){
            Object.keys(packageBrowseData).map((hsData) => 
                hsData !== 'metaData' &&
                Object.keys(packageBrowseData[hsData].productGroups)?.length > 0 &&
                Object.keys(packageBrowseData[hsData].productGroups).forEach((groupData)=> {
                    const productGroup = packageBrowseData[hsData].productGroups[groupData]
                    
                    if(productGroup?.groupOsr === HsPackages?.ctaCheck?.groupOsr){
                        const freeShippingPromo = packageBrowseData[hsData].promoMessagesV2?.find(promo => promo.promoCode?.includes('SENIORSHIP'))
                        const freeShippingPromoThresholdValue = Number.parseInt(freeShippingPromo?.promoCode.split('SENIORSHIP')[0], 10)
                        if (productGroup.products) {
                        	productGroup.products.forEach((product) => {
	                            // define if free shipping promo applicable for the package
	                            const packagePrice = Number.parseFloat(product.retailPrice)
	                            product.freeShipping = 
                                    !Number.isNaN(packagePrice) 
                                    && !Number.isNaN(freeShippingPromoThresholdValue) 
                                    && packagePrice > freeShippingPromoThresholdValue
	                        })
                        }
                        
                        setGradPackageGroupData(productGroup)            
                        if(productGroup.products?.length > 0){
                            const productOsr = productGroup.products[0]?.productOsr
                            const customerNumber = packageBrowseData.metaData.customerNumber
                            const catalog = packageBrowseData[hsData]
                            setPopularPackageName(productGroup.products[0]?.displayName)
                            setPopularPackageProdRefCode(productGroup.products[0]?.prodRefCode)
                            setPopularPackageRepMessage(productGroup.products[0]?.repMessage)
                            setPromoMessages(catalog?.promoMessagesV2);
                            setFeeAlertRequestData({
                                containerSelector: '#promoMsg',
                                customerId: customerNumber,
                                catalogOsr: catalog?.catalogOsr,
                            })
                            setGoogleAnalyticsRequestData({
                                customerNumber,
                                publishedCatalogId: catalog?.publishedCatalogId,
                                sourceCatalogType: catalog?.sourceCatalogType,
                                catalogOsr: catalog?.catalogOsr,
                            });
                            const packageOsrItems = []
                            productGroup.packageItems?.length > 0 &&
                            productGroup.packageItems.forEach((packages) => {
                                packages.packageProductAvailability.forEach((prodAvail) => {
                                    if(prodAvail.packageOsr === productOsr){
                                        packageOsrItems.push(packages)
                                    }
                                })
                            })
                            packageOsrItems?.sort((a,b) => {
                                if (a.orderSequence && b.orderSequence) {
                                    if(a.orderSequence === b.orderSequence) {
                                        return a.displayName > b.displayName ? 1 : -1
                                    }
                                    return  a.orderSequence - b.orderSequence
                                } else if (a.orderSequence) {
                                    return -1
                                } else {
                                    return 1
                                }
                            })
                            setPopularPackageItems(packageOsrItems)
                        }
                    }
                })
            )
        }
        return;
    },[packageBrowseData, HsPackages?.ctaCheck?.groupOsr])

    useEffect(()=>{
        gaPackageBrowsePageLoad();
    },[])

    const getBreadcrumb = useCallback(()=> {
        BREADCRUMB.render(<Breadcrumb pbData={gradPackageGroupData} />)
    },[gradPackageGroupData])

    const getPromoMsg = useCallback(() => {
        const messagesWithLink = appendTermsAndConditionsLink(promoMessages, 'grad-default');
        renderPromoMessages(messagesWithLink);
    }, [promoMessages]);

    const getPopularPackage = useCallback(() => {
        POPULARPACKAGE.render(
            <TermsAndConditionsProvider>
                <PopularPackage
                    firstPackageName={popularPackageName}
                    packageItems={popularPackageItems}
                    hsPopularPackage={HsPopularPackage}
                    popularPackageProdRefCode={popularPackageProdRefCode}
                    isDegreeSelected={true}
                />
            </TermsAndConditionsProvider>
        )
    }, [popularPackageName, popularPackageItems, HsPopularPackage])

    const getHeroBanner = useCallback(() => {
        HEROBANNER.render(
            <TermsAndConditionsProvider>
                <HeroBanner
                    pageContentData={HsHeroBanner}
                    hsPaymentPromo={HsPaymentPromo}
                    hsRepAnnouncement={HsRepAnnouncement}
                    packageGroupData={gradPackageGroupData}
                    repMessage={popularPackageRepMessage}
                    firstPackageName={popularPackageName}
                    googleAnalytics={googleAnalytics}
                />
            </TermsAndConditionsProvider>
        )
    }, [
        HsPaymentPromo,
        HsHeroBanner,
        HsRepAnnouncement,
        gradPackageGroupData,
        popularPackageRepMessage,
        popularPackageName,
        googleAnalytics
    ])

    const getGradPackage = useCallback(() => {
        gradPackageGroupData?.packageItems?.length > 0 && gradPackageGroupData?.products?.length > 0 &&
            PACKAGEGRID.render(
                <TermsAndConditionsProvider>
                    <GradPackageTabs
                        packageList={gradPackageGroupData?.packageItems?.filter(obj => obj.packageProductAvailability?.length > 0)}
                        productList={gradPackageGroupData?.products}
                        pageContentData={HsPackages}
                        hsPaymentPromo={HsPaymentPromo}
                        altImage={HsPopularPackage?.imageUrl}
                        isDegreeSelected={true}
                        googleAnalytics={googleAnalytics}
                    />
                </TermsAndConditionsProvider>
            )
    }, [
        gradPackageGroupData,
        HsPackages,
        HsPaymentPromo,
        googleAnalytics
    ])

    const getTitleBar = useCallback(() => {
        PAGETITLE.render(<TitleBar pageContent={HsPageTitle} affiliationData={affiliationData}/>);
    },[HsPageTitle, affiliationData])

    return (
        <div className = "container-fluid">
            {
                HsPageTitle && Object.keys(HsPageTitle)?.length > 0 && getTitleBar()
            }
            {
                ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()
            }
            {
                PBBreadcrumb && gradPackageGroupData && Object.keys(gradPackageGroupData)?.length > 0 && 
                    getBreadcrumb()
            }
            {
                HsHeroBanner && getHeroBanner()
            }
            {
                HsPopularPackage && getPopularPackage()
            }
            {
                HsPackages && getGradPackage()
            }
        </div>
    )
}